export default function () {
  if($("body").hasClass("forget")){
    passwordForget();
  }
  if($("body").hasClass("new")){
    resetPassword();
    $(".password-eye").on("click",function () {
      $(this).toggleClass("eye-off");
      let input = $(this).prev("input");
      if (input.attr("type") == "password") {
          input.attr("type", "text");
      } else {
          input.attr("type", "password");
      }
    });
  }
  if($("body").hasClass("login-dialog")){
    checkPassword()
    $(".password-eye").on("click",function () {
      $(this).toggleClass("eye-off");
      let input = $(this).prev("input");
      if (input.attr("type") == "password") {
          input.attr("type", "text");
      } else {
          input.attr("type", "password");
      }
    });
    $("input[type='email']").on("input",checkPassword);
    $("input[id='password-confirm']").on("input",checkPassword);
  }

}

const passwordForget =()=>{
  $("#email").on("input",(e)=>{
    //空欄チェックのみにする
    const target = e.target;

    if ($(target).val() !== "") {
      $("#submit").addClass("is-active").removeClass("is-inactive").prop("disabled", false);
    } else {
      $("#submit").removeClass("is-active").addClass("is-inactive").prop("disabled", true);
    }
  })
}

const checkPassword = ()=>{
    const _mail = $("input[type='email']");
    const _pass = $("input[id='password-confirm']");
    if($(_mail).val() !== "" && $(_pass).val() !== "" ){
      $("#login-button").addClass("is-active").removeClass("is-inactive").prop("disabled", false);
    } else {
      $("#login-button").removeClass("is-active").addClass("is-inactive").prop("disabled", true);
    }
}
const resetPassword =()=>{
  $("#password-new").on("input",(e)=>{
    //最低8文字以上、記号を1個以上、英字大文字と数字を含んだもの
    const pattern = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[\/@#*\-_$%^&+=§!\?])[0-9A-Za-z\/@#*\-_$%^&+=§!\?]{8,}$/;
    const target = e.target;

    if (pattern.test($(target).val())){
      $("#password").removeClass("error");
      $(".input-new-text").removeClass("error");

      // to handle unusual case when user enter confirm password first and then new password
      if ($("#password-confirm input").val() === $(target).val()) {
        $("#password-confirm").removeClass("error");
        $(".input-confirm-text").removeClass("error").hide();
        $("#submit").addClass("is-active").removeClass("is-inactive").prop("disabled", false);
      } else {
        $("#password-confirm").addClass("error");
        $(".input-confirm-text").addClass("error").show();
        $("#submit").removeClass("is-active").addClass("is-inactive").prop("disabled", true);
      }
    } else {
      $("#password").addClass("error");
      $(".input-new-text").addClass("error");
    }
  });
  $("#password-confirm").on("input",(e)=>{
    const target = e.target;
    if($("#password-new").val() === $(target).val() ){
      $("#password-confirm").removeClass("error");
      $(".input-confirm-text").removeClass("error").hide();
      $("#submit").addClass("is-active").removeClass("is-inactive").prop("disabled", false);
    } else {
      $("#password-confirm").addClass("error");
      $(".input-confirm-text").addClass("error").show();
      $("#submit").removeClass("is-active").addClass("is-inactive").prop("disabled", true);
    }
  });
}
